import { twMerge } from "tailwind-merge";
import InputDatePicker from "./InputDatePicker";

interface DateRangePickerProps {
    startDate: Date | null;
    endDate: Date | null;
    setStartDate: (value: Date | null) => void;
    setEndDate: (value: Date | null) => void;
    className?: string;
    placeholder?: string;
    disabled?: boolean;
    dateFormat?: string;
    maxDate?: Date;
}

const DateRangePicker = ({
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    className,
    placeholder = "기간",
    disabled,
    dateFormat,
    maxDate,
}: DateRangePickerProps) => {
    const style = twMerge("flex rounded-[6px] bg-white border border-[#E1E2E4]", className);

    return (
        <div className={style}>
            <InputDatePicker
                selected={startDate}
                handleChange={setStartDate}
                placeholder={placeholder}
                className="w-1/2"
                inputClassName="border-none"
                disabled={disabled}
                dateFormat={dateFormat}
                maxDate={maxDate}
                // startDate={startDate ? startDate : undefined}
                // endDate={endDate ? endDate : undefined}
            />
            <InputDatePicker
                selected={endDate}
                handleChange={setEndDate}
                placeholder={placeholder}
                className="w-1/2"
                inputClassName="border-none pl-0"
                disabled={disabled}
                dateFormat={dateFormat}
                minDate={startDate}
                maxDate={maxDate}
                // startDate={startDate ? startDate : undefined}
                // endDate={endDate ? endDate : undefined}
            />
        </div>
    );
};

export default DateRangePicker;
